import type { AxiosRequestConfig } from 'axios';
import type { HipSpineUserPreferenceData } from '@/stores/hipSpinePreferences/types';
import { apiToState, stateToRequest } from '@/api/hipSpinePreferences/mapping';
import {
    getHipSpineUserPreferences,
    putHipSpineUserPreferences,
} from '@/api/hipSpinePreferences/request';

export async function loadHipSpineUserPreferences(
    userId: number,
    config?: AxiosRequestConfig,
): Promise<HipSpineUserPreferenceData | null> {
    const data = await getHipSpineUserPreferences(userId, config);

    if (data) {
        return apiToState(data);
    }

    return null;
}

export async function saveHipSpinePreferences(
    userId: number,
    data: HipSpineUserPreferenceData,
    config?: AxiosRequestConfig,
): Promise<void> {
    const request = stateToRequest(data);
    await putHipSpineUserPreferences(userId, request, config);
}
